var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Component, Emit } from 'vue-property-decorator';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.refresh = function () {
    };
    __decorate([
        Prop({
            required: true,
            type: String
        })
    ], default_1.prototype, "title", void 0);
    __decorate([
        Prop({
            default: "el-icon-refresh",
            type: String
        })
    ], default_1.prototype, "icon", void 0);
    __decorate([
        Prop({
            default: false,
            type: Boolean
        })
    ], default_1.prototype, "hideIcon", void 0);
    __decorate([
        Emit("refresh")
    ], default_1.prototype, "refresh", null);
    default_1 = __decorate([
        Component
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
